import _ from 'lodash';
import { createFeatureSelector, createSelector } from '@ngrx/store';
import { featureKey, SignupState, signupCategoriesState } from '../index';

export const selectSignupState = createFeatureSelector<SignupState>(featureKey);

export const selectCatgoriesState = createSelector(
  selectSignupState,
  (state: SignupState): signupCategoriesState => {
    return state.categories;
  }
)

export const selectCategoryList = createSelector(
  selectCatgoriesState,
  (state: signupCategoriesState) => {
    const categories = _.map(state.entities, entity => entity);
    return categories;
  }
)

export const selectSubCategoryList = createSelector(
  selectCatgoriesState,
  (state: signupCategoriesState) => {
    const categories = _.map(state.entities, entity => entity);
    const selected = _.get(state, 'selected', null);
    const found = _.find(categories, { categoryId: selected });
    return _.get(found, 'subCategories', []);
  }
)
